// src/terms/TermsAGB.jsx
import React from "react";
import { ReactComponent as AGB_icon } from "../icons/AGB_icon.svg";


export function TermsAGB() {
  const wrap = {
    borderRadius: 12,
    background: "#1B202B",
    border: "1px solid rgba(77,100,141,0.9)",
    boxShadow:
      "inset 0 1px 0 rgba(255,255,255,.04), 0 8px 18px rgba(0,0,0,.85)",
    padding: "16px 18px 18px",
    boxSizing: "border-box",
    height: "100%",
    overflowY: "auto",
  };

  const h1 = {
    fontFamily: "DisplayBadge, system-ui, sans-serif",
    fontSize: "var(--fs-18, 18px)",
    letterSpacing: ".18em",
    textTransform: "uppercase",
    color: "#ff8800",
    margin: "0 0 12px",
  };

  const h2 = {
    fontSize: "var(--fs-12, 12px)",
    letterSpacing: ".1em",
    textTransform: "uppercase",
    marginTop: 15,
    marginBottom: 0,
    color: "#82c3ff",
  };

  const p = {
    fontSize: "var(--fs-12, 12px)",
    lineHeight: 1.1,
    color: "rgba(220,230,245,0.88)",
    margin: "1px 0",
  };

  const small = {
    fontSize: 12,
    lineHeight: 1.5,
    color: "rgba(180,190,210,0.75)",
    marginTop: 10,
  };

  const codeBox = {
    fontFamily: " DisplayBadge ",
    fontSize: 11,
    background: "rgba(0,0,0,0.25)",
    borderRadius: 2,
    padding: "6px 8px",
    marginTop: 6,
    marginBottom: 6,
  };

  return (
    <div style={wrap}>
     <h1 style={{
    ...h1,
    display: "flex",
    alignItems: "center",
    gap: 6,
    marginBottom: 30,
  }}
>
  <AGB_icon
    width={28}
    height={28}
    aria-hidden="true"
    style={{ flexShrink: 0, transform: "translateY(-0.5px)" }}
  />
  <span>LegendsTools AGB | Nutzungsbedingungen | Online DIENSTE</span></h1>

      {/* Anbieter */}
      <h2 style={h2}>§1 Anbieter</h2>
      <p style={p}>mts individual carstyling GmbH
      <br />
      Rilkestrasse 32b
      <br />
      37120 Bovenden
      <br />
      Deutschland
      <br />
      <br />
      Telefon: 0551 291 250 30
      <br /> 
      E-Mail: info@legendstools.de, support@mts-carstyling.de
      <br /> 
      Web: https://legendstools.de 
      <br />
      <br /> 
      Vertreten durch die Geschäftsführung: Marcus Brocks
      <br /> 
    
      Registergericht: Amtsgericht Göttingen
      <br /> 
      Handelsregister-Nummer: HRB 205531 
      <br />
      Umsatzsteuer-Identifikationsnummer gemäß § 27 a Umsatzsteuergesetz:
      <br /> 
      DE178253901
      <br />
      </p>

      
      {/* Vertretungsberechtigter */}
      <h2 style={h2}>§2 Gegenstand des Dienstes</h2>
      <p style={p}>
      (1) Legendstools stellt Nutzern eine Online-Plattform mit Analyse-, Statistik- und Kartenwerkzeugen 
      für browserbasierte Strategiespiele zur Verfügung.
      <br />
      <br />
      (2) Die Nutzung ist grundsätzlich kostenfrei.
      Einige Funktionen (z. B. personalisierte Einstellungen, Allianz-Management, Account-zuordnung, serverbezogene
      Favoriten) erfordern ein kostenfreies Nutzerkonto.
      <br />
      <br />
      (3) Legendstools ist kein Produkt der Travian Games GmbH und steht in keiner geschäftlichen Verbindung zu ihr.
      </p>
     


      {/* 3. COOKIES */}
      <h2 style={h2}>§3 Nutzerkonto</h2>
      <p style={p}>
      (1) Für bestimmte Funktionen ist eine Registrierung erforderlich.
      Erhobene Daten sind auf das technisch notwendige Maß beschränkt.
      <br />
      <br />
      (2) Nutzer sind verpflichtet, Zugangsdaten geheim zu halten und ausschließlich eigene Spiel- oder Accountdaten zu verknüpfen.
      <br />
      <br />
      (3) Jederzeitige Kündigung:
      Das Konto kann durch eine E-Mail an support@legendstools.de oder durch Nichtnutzung gelöscht bzw. deaktiviert werden.
      </p>


      {/* 3. COOKIES */}
      <h2 style={h2}>§4 Nutzung der Plattform</h2>
      <p style={p}>
      (1) Legendstools darf ausschließlich im Rahmen der bereitgestellten Funktionen genutzt werden.
      <br />
      <br />
      (2) Es ist untersagt,
      <br />
      <br />
      • Sicherheitsmechanismen zu umgehen,
      <br />
      • automatisierte Abrufe, Bots oder Scraper zu verwenden,
      <br />
      • rechtswidrige Inhalte zu speichern oder zu verarbeiten,
      <br />
      • Daten anderer Nutzer ohne deren Zustimmung auszulesen,
      <br />
      • externe Travian-Accounts fremder Personen einzutragen.
      <br />
      <br />
      (3) Legendstools kann Funktionsbereiche jederzeit ändern, erweitern oder einschränken.
      <br />
      <br />
      Ein Anspruch auf Verfügbarkeit bestimmter Module besteht nicht.
      </p>

      {/* 4. KONTAKT */}
      <h2 style={h2}>§5 Verfügbarkeit</h2>
      <p style={p}>
      (1) Legendstools wird technisch sorgfältig betrieben, es besteht jedoch kein Anspruch auf ununterbrochene oder fehlerfreie Verfügbarkeit.
      <br />
      <br />
      (2) Wartungen, Weiterentwicklungen oder technische Störungen können zu Einschränkungen führen.
      </p>

       {/* 6. Haftung */}
       <h2 style={h2}>§6 Haftung</h2>
      <p style={p}>
      (1) Für kostenlose Dienste haftet der Anbieter nur bei Vorsatz oder grober Fahrlässigkeit.
      <br />
      <br />
      (2) Keine Haftung besteht insbesondere für:
      <br />
      <br />
      • Datenverlust aufgrund fehlerhafter Eingaben oder externer Störungen,
      <br />
      • Ausfälle von Servern, Netzwerken oder Drittanbietern,
      <br />
      • Veränderungen oder Einschränkungen seitens Travian oder anderer externer Anbieter.
      <br />
      <br />
      (3) Unberührt bleiben Ansprüche wegen Verletzung von Leben, Körper oder Gesundheit.
      </p>

      {/* 7. KONTAKT */}
      <h2 style={h2}>§7 Datenverarbeitung</h2>
      <p style={p}>
      (1) Die Verarbeitung personenbezogener Daten richtet sich nach der auf der Website einsehbaren Datenschutzerklärung.
      <br />
      <br />
      (2) Legendstools setzt ausschließlich technisch notwendige Cookies bzw. Session-Technologien ein.
      </p>

      {/* 8. KONTAKT */}
      <h2 style={h2}>§8 Geistiges Eigentum</h2>
      <p style={p}>
      Alle Inhalte, Grafiken, Texte, Tools, Codes und Designs von Legendstools sind rechtlich geschützt.
      <br />
      Das Kopieren, Weiterverwenden oder Veröffentlichen ohne Genehmigung ist untersagt.
      <br />
      mts individual® ist eingetragenes Warenzeichen der mts individual carstyling GmbH.
      </p>

      {/* 8. KONTAKT */}
      <h2 style={h2}>§9 Änderungen der AGB</h2>
      <p style={p}>
      Der Anbieter kann diese AGB anpassen, wenn hierfür ein sachlicher Grund besteht (z. B. technische Weiterentwicklung, rechtliche Änderungen).
      Nutzer werden über wesentliche Änderungen informiert.
      </p>

      {/* 8. KONTAKT */}
      <h2 style={h2}>§10 Schlussbestimmungen</h2>
      <p style={p}>
      Es gilt das Recht der Bundesrepublik Deutschland.
      Gerichtsstand ist – soweit gesetzlich zulässig – Göttingen.

      Sollten einzelne Bestimmungen unwirksam sein, bleibt die Wirksamkeit der übrigen Regelungen unberührt.
      </p>
      <br />
      <br />

      Version 1.1 – Stand: November 2025
      Legendstools ist ein digitales Angebot der mts individual carstyling GmbH.










      <div style={small}>
      Copyright © 2025 mts individual carstyling GmbH, Germany. Alle Rechte vorbehalten.
      <br />
      Legendstools ist ein digitales Angebot der mts individual carstyling GmbH.
      mts individual® ist eingetragenes Warenzeichen der mts individual carstyling GmbH. 
      </div>
    </div>
  );
}


